import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { pageView } from '../../utils/segmentService';

const PageView: React.FC = () => {
  const location = useLocation();
  const [previousPage, setPreviousPage] = useState('initial');



  useEffect(() => {
    const pageTitle = document.title; // Get the page title
    if (previousPage !== location.pathname) {
      setPreviousPage(location.pathname);
      pageView(pageTitle, { path: location.pathname });
    }
  }, [location, previousPage, setPreviousPage]);

  return <></>;
};

export default PageView;
